var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal__comments-container" }, [
    _c("div", { staticClass: "modal__comments-header" }, [
      _c("i", { staticClass: "far fa-comments" }),
      _vm._v(" " + _vm._s(_vm.commentCountText))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid modal__comments-area" }, [
      _c(
        "div",
        { staticClass: "grid__col--6" },
        [_c("CommentsDisplay", { attrs: { comments: _vm.comments } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--6" }, [_c("CommentForm")], 1)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }